import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IconDone from '../../components/icons/IconDone';
import IconConversation from '../../components/icons/IconConversation';
import IconFileText from '../../components/icons/IconFileText';
import IconMarkerImportant from '../../components/icons/IconMarkerImportant';
import IconCanvasOpen from '../../components/icons/IconCanvasOpen';
import IconActivity from '../../components/icons/IconActivity';
import * as api from './api';
import '../../css/modals.css';
import '../../css/course-dependencies.css';

// Order and wording match what the backend counts (CourseDependencyService
// .studentRows). tip is the hover text - it explains what the number means,
// since the icons alone don't say whether it's answers or attempts.
const CATEGORIES = [
   { code: 'answers', short: 'відповіді', Icon: IconDone, tip: 'Збережені відповіді студента на інтерактивні вправи цього курсу' },
   { code: 'conversations', short: 'розмови', Icon: IconConversation, tip: 'Записи прогресу розмов (діалогових тестів), які студент проходив у цьому курсі' },
   { code: 'notes', short: 'нотатки', Icon: IconFileText, tip: 'Нотатки студента до блоків цього курсу' },
   { code: 'markers', short: 'маркери', Icon: IconMarkerImportant, tip: 'Маркери, які студент ставив на блоки цього курсу' },
   { code: 'canvas', short: 'канвас', Icon: IconCanvasOpen, tip: 'Елементи канвасу (малюнки, позначки на полотні), які студент додав у цьому курсі' },
   { code: 'logs', short: 'журнал', Icon: IconActivity, tip: 'Записи журналу активності студента в цьому курсі' },
];

export default function CourseStudentsModal({ isOpen, onClose, courseId }) {
   const navigate = useNavigate();
   const [rows, setRows] = useState([]);
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState('');

   useEffect(() => {
      if (!isOpen) return;
      setLoading(true);
      setError('');
      api.getCourseStudents(courseId)
         .then((response) => setRows(response.data))
         .catch((err) => {
            if (err.response && err.response.status === 401) navigate('/login');
            setError('Не вдалося завантажити список студентів.');
         })
         .finally(() => setLoading(false));
   }, [isOpen, courseId, navigate]);

   if (!isOpen) return '';

   const stopProp = (e) => e.stopPropagation();

   const openStudent = (row) => {
      onClose();
      navigate('/students/' + row.studentId + '/workspace/' + courseId);
   };

   return (
      <div className='modal-update' onClick={onClose} style={{ display: 'flex' }}>
         <div className='modal-window course-deps-modal' onClick={stopProp}>
            <div className='course-deps-head'>
               <h3 className='modal-w-title'>Студенти курсу</h3>
               <div className='course-deps-sub'>
                  Натисніть рядок, щоб відкрити роботу студента в цьому курсі. Цифри - скільки даних збережено в його просторі.
               </div>
               <div className='course-students-legend'>
                  {CATEGORIES.map((c) => (
                     <span key={c.code} className='course-students-legend-item' title={c.tip}>
                        <c.Icon style={{ width: 14, height: 14 }} />
                        <span>{c.short}</span>
                     </span>
                  ))}
               </div>
            </div>
            <div className='course-deps-body'>
               {loading ? (
                  <div className='course-deps-muted'>Завантаження...</div>
               ) : error ? (
                  <div className='course-deps-error'>{error}</div>
               ) : rows.length === 0 ? (
                  <div className='course-deps-muted'>Цей курс ще не призначено жодному студенту.</div>
               ) : rows.map((row) => (
                  <div key={row.studentCourseId} className='course-students-row' onClick={() => openStudent(row)}>
                     <div className='course-students-name'>
                        <span className='course-students-name-text'>{row.studentName}</span>
                        {row.groupName ? <span className='course-deps-muted'>{row.groupName}</span> : ''}
                        {row.workspaceId == null ? <span className='course-deps-muted'>ще не відкривав курс</span> : ''}
                     </div>
                     <div className='course-students-counts'>
                        {CATEGORIES.map((c) => {
                           const n = row.counts[c.code] || 0;
                           return (
                              <div key={c.code} className={'course-students-count' + (n === 0 ? ' is-zero' : '')} title={c.tip}>
                                 <c.Icon style={{ width: 14, height: 14 }} />
                                 <b>{n}</b>
                              </div>
                           );
                        })}
                     </div>
                  </div>
               ))}
            </div>
            <div className='course-deps-foot'>
               <button type='button' className='form-button' onClick={onClose}>Закрити</button>
            </div>
         </div>
      </div>
   );
}
